export const ECOBANK_PAYMENT_STATE = Object.freeze({
  FRESH: 'FRESH',
  INITIATING: 'INITIATING',
  INITIATION_FAILED: 'INITIATION_FAILED',
  AUTHORIZATION_REQUIRED: 'AUTHORIZATION_REQUIRED',
  VALIDATING: 'VALIDATING',
  CONFIRMED: 'CONFIRMED',
  REJECTED: 'REJECTED',
  INDETERMINATE: 'INDETERMINATE',
});

// Temporary development switches. Replace this boundary with the authoritative
// Ecobank payment summary once the backend contract is available.
export const ECOBANK_DEVELOPMENT = Object.freeze({
  invoiceId: null,
  flags: Object.freeze({
    initiationLoading: false,
    initiationFailed: false,
    authorizationRequired: false,
    validationProcessing: false,
    confirmed: false,
    rejected: false,
    indeterminate: false,
  }),
  maskedAccount: '••••••••4821',
  safeRejectionReason: null,
});

const FLAG_STATES = [
  ['initiationLoading', ECOBANK_PAYMENT_STATE.INITIATING],
  ['initiationFailed', ECOBANK_PAYMENT_STATE.INITIATION_FAILED],
  ['authorizationRequired', ECOBANK_PAYMENT_STATE.AUTHORIZATION_REQUIRED],
  ['validationProcessing', ECOBANK_PAYMENT_STATE.VALIDATING],
  ['confirmed', ECOBANK_PAYMENT_STATE.CONFIRMED],
  ['rejected', ECOBANK_PAYMENT_STATE.REJECTED],
  ['indeterminate', ECOBANK_PAYMENT_STATE.INDETERMINATE],
];

export const resolveEcobankPaymentState = (flags = {}) => {
  const enabledStates = FLAG_STATES.filter(([flag]) => flags[flag]);

  if (enabledStates.length > 1) {
    throw new Error('Only one Ecobank development state may be enabled at a time.');
  }

  return enabledStates[0]?.[1] || ECOBANK_PAYMENT_STATE.FRESH;
};

export const getEcobankRowStatus = (state) =>
  ({
    [ECOBANK_PAYMENT_STATE.INITIATING]: ECOBANK_LOCALES.row.initializing,
    [ECOBANK_PAYMENT_STATE.AUTHORIZATION_REQUIRED]: ECOBANK_LOCALES.row.authorization,
    [ECOBANK_PAYMENT_STATE.VALIDATING]: ECOBANK_LOCALES.row.validating,
    [ECOBANK_PAYMENT_STATE.INDETERMINATE]: ECOBANK_LOCALES.row.indeterminate,
  }[state] || null);

export const isEcobankTransactionLocked = (state) =>
  [
    ECOBANK_PAYMENT_STATE.INITIATING,
    ECOBANK_PAYMENT_STATE.AUTHORIZATION_REQUIRED,
    ECOBANK_PAYMENT_STATE.VALIDATING,
    ECOBANK_PAYMENT_STATE.INDETERMINATE,
  ].includes(state);

export const canStartEcobankPayment = (state) =>
  [ECOBANK_PAYMENT_STATE.FRESH, ECOBANK_PAYMENT_STATE.INITIATION_FAILED, ECOBANK_PAYMENT_STATE.REJECTED].includes(
    state
  );

export const getEcobankExpandedCopy = (state) =>
  ({
    [ECOBANK_PAYMENT_STATE.INITIATING]: {
      title: ECOBANK_LOCALES.expanded.initializing_title,
      description: ECOBANK_LOCALES.expanded.initializing_description,
    },
    [ECOBANK_PAYMENT_STATE.AUTHORIZATION_REQUIRED]: {
      title: ECOBANK_LOCALES.expanded.authorization_title,
      description: ECOBANK_LOCALES.expanded.authorization_description,
    },
    [ECOBANK_PAYMENT_STATE.VALIDATING]: {
      title: ECOBANK_LOCALES.expanded.validating_title,
      description: ECOBANK_LOCALES.expanded.validating_description,
    },
    [ECOBANK_PAYMENT_STATE.INDETERMINATE]: {
      title: ECOBANK_LOCALES.expanded.indeterminate_title,
      description: ECOBANK_LOCALES.message.indeterminate_lock,
    },
  }[state] || null);
import Locales from 'locales';

const ECOBANK_LOCALES = Locales.invoice.ecobank;
